<template>
    <div id="mapActionButtonWrapper" class="d-flex">
        <button 
        v-if="buttons.findBuilding"
        @click="goToRoute('/buildingto')"
        class="btn-uofg-primary"
        >Find a building</button>
        <button 
        v-if="buttons.directions"
        @click="emit('showDrawer','Directions')"
        class="btn-uofg-primary"
        >
            <font-awesome-icon icon="diamond-turn-right"></font-awesome-icon>
            Directions
        </button>
        <button 
        v-if="buttons.mapFeatures"
        @click="emit('showDrawer','Map Features')"
        class="btn-uofg-primary"
        >Select Features</button>
    </div>
    <div id="accessibilityGuideWrap">
        <a 
            v-if="props.accessUrl" 
            id="accessibilityGuide"
            :href="props.accessUrl" 
            target="_blank"
        >
            Accessibility Guide <font-awesome-icon icon="arrow-up-right-from-square"></font-awesome-icon>
        </a>
    </div>
</template>
<script setup>
import {defineEmits, ref, onMounted, defineProps} from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()
const emit = defineEmits(['showDrawer'])

const props = defineProps({
    locationName: String,
    accessUrl: String
})

//Buttons
const buttons = ref({
    findBuilding: true,
    mapFeatures: true,
    directions: false,
    currentLocation: false,
})

onMounted(
  () => {
    checkRoute()
  }
)

/**
 * Check if the currnt url/path has a 'buildingId' query param. If so, show the direction button and hide find a building
 * 
 * @returns {void}
 */
function checkRoute() {
    //Initial map, has no query string = Show find a building
    const currentRoute = router.currentRoute.value
    if(currentRoute.path === "/map") {
        if(currentRoute.query.buildingId) {
            buttons.value.directions = true
            buttons.value.findBuilding = false
        } else {
        console.log("no building")
        }
    }
}

/**
 * Push path to router after adding features url query
 * 
 * @returns {void}
 */
function goToRoute(path) {
     const featuresQuery =  route.query.features
     const showAccessibleRoutesQuery = route.query.showAccessibleRoutes
     router.push({path: path, query:{features: featuresQuery, showAccessibleRoutes: showAccessibleRoutesQuery}})
}
</script>
<style>
#mapActionButtonWrapper {
    background: var(--uog-blue-10);
    padding: 0.3rem;
}

#mapActionButtonWrapper button {
    width: 100%;
    background-color: #fff;
    color: var(--uog-dark-blue);
    margin-left:10px;
    border-radius: 5px;
}

#mapActionButtonWrapper button:not(:first-child) {
    margin-right:10px;
}

#mapActionButtonWrapper button:hover {
    background-color: var(--uog-dark-blue);
    color: #fff;
}

#mapActionButtonWrapper button:active {
    background-color: #fff;
    color: var(--uog-dark-blue);
}

#accessibilityGuideWrap {
    background: var(--uog-blue-10);
    text-align: right;
}

#accessibilityGuide {
    display: inline-block;
    padding: 0px 1rem 0.5rem 1rem;
    color: var(--uog-dark-blue);
    text-decoration: none;
}

#accessibilityGuide:hover,
#accessibilityGuide:active {
    text-decoration:underline;
}

@media (max-width:370px) {
    #mapActionButtonWrapper button {
        padding: 5px;
    }
}
</style>